const indexTopics = [
  {
    title: '今日娱乐圈爆料',
    desc: '明星动态、综艺内幕、影视剧透一站打尽，每日更新最劲爆娱乐话题。',
    tag: '娱乐',
    icon: 'ri-star-smile-line',
  },
  {
    title: '社会热点追踪',
    desc: '社会事件、民生话题、争议讨论持续跟进，还原事件全貌。',
    tag: '社会',
    icon: 'ri-earth-line',
  },
  {
    title: '科技圈最新动态',
    desc: '科技产品发布、行业大事件、互联网新趋势，每日精选科技爆料。',
    tag: '科技',
    icon: 'ri-cpu-line',
  },
  {
    title: '体育赛事爆料',
    desc: '赛事前瞻、转会传闻、赛场内外花絮，体育迷的每日必看。',
    tag: '体育',
    icon: 'ri-basketball-line',
  },
  {
    title: '财经热点速递',
    desc: '市场动态、企业内幕、投资风向标，财经爆料每日不间断。',
    tag: '财经',
    icon: 'ri-funds-line',
  },
  {
    title: '网络热门话题',
    desc: '热搜话题、网络梗、社区讨论热度排行，掌握网络脉搏。',
    tag: '话题',
    icon: 'ri-chat-smile-2-line',
  },
  {
    title: '海外爆料精选',
    desc: '国际热点、海外趣闻、跨境话题，全球爆料一手掌握。',
    tag: '国际',
    icon: 'ri-global-line',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            爆料合集
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            七大专题分类，每日精选爆料内容，助你快速锁定关注领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexTopics.slice(0, 4).map((topic, i) => (
            <a
              key={i}
              href="#"
              className="group block p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer no-underline"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${topic.icon} text-xl text-primary-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                      {topic.title}
                    </h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {topic.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {topic.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {indexTopics.slice(4).map((topic, i) => (
            <a
              key={i + 4}
              href="#"
              className="group block p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all cursor-pointer no-underline"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${topic.icon} text-xl text-accent-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                      {topic.title}
                    </h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                      {topic.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {topic.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}